export default __webpack_public_path__ + "static/media/avatar_50.d710c5e3.png";